import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ServiceCardProps {
  image: string;
  title: string;
  description: string;
  link?: string;
}
export function ServiceCard({
  image,
  title,
  description,
  link
}: ServiceCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-362">
      <div className="h-48 overflow-hidden" data-id="element-363">
        <img src={image} alt={title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" data-id="element-364" />
      </div>
      <div className="p-6" data-id="element-365">
        <h3 className="text-xl font-bold text-[#0B1F3A] mb-3" data-id="element-366">{title}</h3>
        <p className="text-gray-600 mb-4" data-id="element-367">{description}</p>
        {link && <a href={link} className="inline-flex items-center text-[#E63946] font-semibold hover:text-[#D32F2F] transition-colors" data-id="element-368">
            Learn More
            <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-369" />
          </a>}
      </div>
    </div>;
}